import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const HeroContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    height: '100vh',
    minHeight: '600px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    marginBottom: theme.spacing(8),
}));

export const HeroContent = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(8, 4),
    },
    maxWidth: '1200px',
    zIndex: 1,
}));
